export const SEO_DEFAULT_TITLE = 'Protocol Goida';
export const SEO_DEFAULT_DESCRIPTION = 'Protocol Goida — сервис VPN и прокси для Telegram, игр, смены региона и безопасного подключения без лишней сложности.';

export const PAGE_SEO_CONTENT = {
  home: {
    key: 'home',
    path: '/',
    title: SEO_DEFAULT_TITLE,
    description: 'Protocol Goida — VPN и прокси для Telegram, игр и смены региона. Быстрые тарифы, удобное подключение и поддержка популярных сценариев.',
    robots: 'index,follow,max-image-preview:large',
    ogType: 'website',
    prerenderHtml: `
      <main data-seo-prerender="home">
        <section>
          <h1>Protocol Goida — VPN и прокси для Telegram, игр и смены региона</h1>
          <p>Protocol Goida помогает подключить VPN и прокси для Telegram, обхода ограничений, игр и безопасного повседневного использования.</p>
        </section>
        <section>
          <h2>Что даёт сервис</h2>
          <ul>
            <li>VPN и прокси для Telegram</li>
            <li>Смена региона для приложений и сервисов</li>
            <li>Подключение для игр и обхода ограничений</li>
            <li>Выбор тарифов и поддержка популярных устройств</li>
          </ul>
        </section>
        <section>
          <h2>Тарифы и локации</h2>
          <p>На сайте доступны тарифы Protocol Goida, выбор локаций, FAQ, а также инструкции по подключению прокси и Telegram.</p>
        </section>
      </main>
    `.trim(),
  },
  proxy: {
    key: 'proxy',
    path: '/proxy',
    title: 'Прокси для Telegram | Protocol Goida',
    description: 'Подключите прокси для Telegram через Protocol Goida. Быстрые инструкции, рабочие ссылки и удобное подключение без лишних шагов.',
    robots: 'index,follow,max-image-preview:large',
    ogType: 'website',
    prerenderHtml: `
      <main data-seo-prerender="proxy">
        <section>
          <h1>Прокси для Telegram от Protocol Goida</h1>
          <p>Страница Protocol Goida с настройкой прокси для Telegram: подключение, инструкции, параметры сервера и удобный переход в приложение.</p>
        </section>
        <section>
          <h2>Как подключить прокси</h2>
          <ol>
            <li>Откройте страницу прокси Protocol Goida.</li>
            <li>Нажмите кнопку подключения в Telegram.</li>
            <li>Подтвердите добавление прокси в приложении.</li>
          </ol>
        </section>
        <section>
          <h2>Для чего подходит прокси</h2>
          <p>Прокси помогает открыть Telegram в ограниченных регионах, восстановить доступ к мессенджеру и использовать сервис без лишней ручной настройки.</p>
        </section>
      </main>
    `.trim(),
  },
  termsPolicy: {
    key: 'termsPolicy',
    path: '/terms-policy',
    title: 'Условия использования и политика | Protocol Goida',
    description: 'Условия использования сервиса Protocol Goida и политика обработки данных. Актуальная информация о правилах работы и конфиденциальности.',
    robots: 'index,follow,max-image-preview:large',
    ogType: 'article',
    prerenderHtml: `
      <main data-seo-prerender="terms-policy">
        <section>
          <h1>Условия использования и политика Protocol Goida</h1>
          <p>На этой странице размещены актуальные условия использования сервиса Protocol Goida и политика обработки данных.</p>
        </section>
        <section>
          <h2>Что можно найти на странице</h2>
          <ul>
            <li>Правила использования сервиса</li>
            <li>Порядок обработки данных</li>
            <li>Основные ограничения и обязанности сторон</li>
          </ul>
        </section>
      </main>
    `.trim(),
  },
};
